import { render, staticRenderFns } from "./ApiList.vue?vue&type=template&id=28fdb169&scoped=true"
import script from "./ApiList.vue?vue&type=script&lang=ts"
export * from "./ApiList.vue?vue&type=script&lang=ts"
import style0 from "./ApiList.vue?vue&type=style&index=0&id=28fdb169&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fdb169",
  null
  
)

export default component.exports